import { useState, useEffect, useRef } from 'react';
import '../styles/OfflineBanner.css';

export default function OfflineBanner() {
  const [online, setOnline] = useState(
    typeof navigator !== 'undefined' ? navigator.onLine : true
  );
  const [dismissed, setDismissed] = useState(false);
  const [showReconnect, setShowReconnect] = useState(false);
  const wasOfflineRef = useRef(!online);
  const reconnectTimer = useRef(null);

  useEffect(() => {
    const handleOnline = () => {
      if (wasOfflineRef.current) {
        setShowReconnect(true);
        setDismissed(false);
        reconnectTimer.current = setTimeout(() => setShowReconnect(false), 3000);
      }
      setOnline(true);
      wasOfflineRef.current = false;
    };

    const handleOffline = () => {
      setOnline(false);
      setDismissed(false);
      setShowReconnect(false);
      wasOfflineRef.current = true;
    };

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
      clearTimeout(reconnectTimer.current);
    };
  }, []);

  if (online && !showReconnect) return null;
  if (!online && dismissed) return null;

  return (
    <div
      className={`offline-banner ${showReconnect ? 'offline-banner--reconnect' : ''}`}
      role="alert"
    >
      <span className="offline-banner__text">
        {showReconnect
          ? 'Back online!'
          : "You\u2019re offline. Some features may be unavailable."}
      </span>
      {!showReconnect && (
        <button
          className="offline-banner__dismiss"
          onClick={() => setDismissed(true)}
          aria-label="Dismiss offline notice"
        >
          &times;
        </button>
      )}
    </div>
  );
}
